import React from 'react';
import { Box, Typography, Link } from '@mui/material';

const BackgroundBox = ({ 
  image, 
  overlayColor = 'rgba(2, 0, 0, 0.88)', 
  title = '', 
  titleColor = '#ffffff', 
  titleSize = '2.2rem',
  hoverText = 'Texto adicional ao passar o mouse', 
}) => {
  return (
    <Box 
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
        position: 'relative', // Torna este container pai relativo
        width: '250px', // Ajusta o tamanho do contêiner
        height: '250px', // Ajusta o tamanho do contêiner
        '&:hover .hover-box, .hover-box:hover': { // Mantém o hover ativo na caixa também
          opacity: 1, // Mostra a caixa ao passar o mouse
          transform: 'translateY(0)', // Anima para a posição correta
        },
      }}
    >
      {/* Caixa principal com imagem e sobreposição */}
      <Box
        sx={{
          position: 'relative',
          height: '100%', 
          width: '100%', 
          overflow: 'hidden', 
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          textAlign: 'center', 
          borderRadius: '4px',
          '&:hover img': {
            transform: 'scale(1.2)', // Zoom na imagem ao hover
          },
          '&:hover .overlay': {
            opacity: 0.5, // Diminui a opacidade da camada escura no hover
          },
        }}
      >
        {/* Imagem de fundo */}
        <Box
          component="img"
          src={image}
          alt="background"
          sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            height: '100%',
            width: '100%',
            objectFit: 'cover',
            transition: 'transform 0.3s ease-in-out', 
          }}
        />

        {/* Camada escura */}
        <Box
          className="overlay"
          sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            height: '100%',
            width: '100%',
            backgroundColor: overlayColor,
            zIndex: 2,
            transition: 'opacity 0.3s ease-in-out', 
          }}
        />

        {/* Título centralizado */}
        <Typography
          variant="h1"
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            zIndex: 3,
            color: titleColor, 
            fontSize: titleSize, 
            fontWeight: 'bold', 
            pointerEvents: 'none', 
          }}
        >
          {title}
        </Typography>
      </Box>

      {/* Div abaixo que aparece ao hover */}
      <Box
        className="hover-box"
        sx={{
          position: 'absolute', // Para posicionar em relação ao pai
          top: 'calc(100% + 10px)', // 10px abaixo do elemento principal
          backgroundColor: '#ffffff',
          padding: '10px',
          borderRadius: '4px',
          boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)', 
          textAlign: 'center',
          zIndex: 10,
          width: '200px',
          opacity: 0, // Inicialmente invisível
          transition: 'opacity 0.3s ease, transform 0.3s ease', 
        }}
      >
        <Typography variant="body2" sx={{ color: '#333', marginBottom: '5px' }}>
          {hoverText}
        </Typography>
        <Link
          href="https://wa.me/551143579243"
          target="_blank"
          rel="noopener noreferrer"
          sx={{
            color: '#007BFF',
            fontWeight: 'bold',
            textDecoration: 'none',
            '&:hover': {
              textDecoration: 'underline',
            },
          }}
        >
          Saiba mais
        </Link>
      </Box>
    </Box>
  );
};

export default BackgroundBox;
